var _style, _rect, _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 23.31 21.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .cal0{display:none;fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n        .cal1{fill:none;stroke-width:1.3;stroke-miterlimit:10;}\n        .cal2{stroke-width:1.3;stroke-miterlimit:10;}\n    ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -7.33,
    y: -6.14,
    className: "cal0",
    width: 9.5,
    height: 10.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cal1",
    d: "M21.61,20.67H1.67c-0.56,0-1.01-0.45-1.01-1.01V1.69c0-0.56,0.45-1.01,1.01-1.01h19.94         c0.56,0,1.01,0.45,1.01,1.01v17.97C22.62,20.22,22.17,20.67,21.61,20.67z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cal2",
    d: "M17.98,6.58H5.3c-0.49,0-0.88-0.4-0.88-0.88v0c0-0.49,0.4-0.88,0.88-0.88h12.68c0.49,0,0.88,0.4,0.88,0.88v0         C18.87,6.18,18.47,6.58,17.98,6.58z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cal3",
    cx: 18.29,
    cy: 16.47,
    r: 1.02
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8863771276317e9b2951f8c05d8f4d21.svg";
export { ForwardRef as ReactComponent };